import React from 'react';
import RefreshIndicator from 'material-ui/RefreshIndicator';

const LoadingIndicator = React.createClass({
	render: function() {
		const style = {
			marginLeft: '50%',
			boxShadow: 'none',
		};
		return (
			<div className="refresh">
				<RefreshIndicator
					size={40}
					top={100}
					left={-20}
					style={style}
					status="loading"
				/>
			</div>
		)
	}
});

export default LoadingIndicator;


// WEBPACK FOOTER //
// ./src/components/loadingIndicator.jsx